import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class MiniAppSelectAccountRequest
*  Запрос завершения входа после выбора аккаунта Telegram Mini App
*/
export class MiniAppSelectAccountRequest extends ActiveModel {

/**
  * token
  * Токен стадии выбора, выданный `POST auth/mini-app`
  */
  @ActiveField('')
  token: string = ''


  /**
  * userId
  * Идентификатор выбранного аккаунта<br>  */
  @ActiveField(0)
  userId: number = 0
}
